import { Directive, ElementRef, Input, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';

@Directive({
  selector: '[appLazyVideo]'
})
export class LazyVideoDirective implements OnInit, OnDestroy {
  @Input('appLazyVideo') src: string;
  @Output() played = new EventEmitter<string>();
  
  private observer: IntersectionObserver;

  constructor(private el: ElementRef<HTMLVideoElement>) {}

  ngOnInit() {
    this.observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const video = this.el.nativeElement;
        if (entry.isIntersecting) {
          if (!video.src && this.src) {
            video.src = this.src;
            video.load();
          }
          video.muted = true;
          video.play().then(() => {
            this.played.emit(video.id);
          }).catch(err => {
            // Auto-play might be blocked
          });
        } else {
          video.pause();
        }
      });
    }, {
      threshold: 0.5
    });

    this.observer.observe(this.el.nativeElement);
  }

  ngOnDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}
